import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deviation',
  templateUrl: './deviation.component.html',
  styleUrls: ['./deviation.component.scss']
})
export class DeviationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
